module.exports = __webpack_public_path__ + "img/person-2.7610e8c3.svg";